var _excluded = ["children", "isDisabled", "shouldShowLabel", "label", "aria-label"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { forwardRef, omitThemingProps } from '../../system';
import { __DEV__ } from '../../utils';
import { Button, IconButton } from '../button';
import { Icon } from '../icon';
var CloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  width: 3,
  viewBox: "0 0 352 512",
  focusable: "false",
  "aria-hidden": true
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
}));
/**
 * A button with a close icon.
 *
 * It is used to handle the close functionality in feedback and overlay components
 * like Alerts, Toasts, Drawers and Modals.
 */
export var CloseButton = forwardRef((props, ref) => {
  // const styles = useStyleConfig('CloseButton', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      children,
      // __css,
      isDisabled,
      shouldShowLabel = true,
      label = 'Close',
      'aria-label': ariaLabel = 'Close'
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _shouldShowLabel = shouldShowLabel && !children && !!label;
  var _children = children || /*#__PURE__*/React.createElement(CloseIcon, {
    ml: _shouldShowLabel ? 2 : undefined,
    boxSize: 4
  });
  if (!_shouldShowLabel) {
    return /*#__PURE__*/React.createElement(IconButton, _extends({
      ref: ref,
      "aria-label": ariaLabel,
      disabled: isDisabled
    }, rest), _children);
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": ariaLabel,
    variant: "tertiary",
    size: "xs",
    ref: ref,
    isDisabled: isDisabled
  }, rest), _shouldShowLabel && label, _children);
});
if (__DEV__) {
  CloseButton.displayName = 'CloseButton';
}